export const PaymentStatusColor: {
	[key: string]: string;
} = {
	overdue: 'red',
	paid: 'green',
	pending: 'yellow',
};
